import React from "react";

export const Header = () => {
  return (
    <section className="header">
      <div className="left-side">
        <h1 className="title">Conatct US</h1>
      </div>
      <div className="right-side">
        <h2 className="title">Get in Touch</h2>
        <div className="text">
          If you have any queries, please feel free to fill out the form and one
          of our representatives will get in contact with you.
        </div>
      </div>
    </section>
  );
};
